import React, { PureComponent } from 'react';

/**
 * Displays company logo and fallback image in case the logo cannot be loaded.
 *
 * @class CompanyLogo
 * @extends {PureComponent}
 */
export default class CompanyLogo extends PureComponent {
    // use this flag to prevent 'flashing' for 404 images
    state = { loaded: false };

    render() {
        const { loaded } = this.state;
        const { agreementNumber } = this.props;

        return (
            <img
                style={{
                    opacity: loaded ? 1 : 0,
                }}
                src={`${process.env.REACT_APP_ECONOMIC_PATH}/internal-api/agreements/logo/${agreementNumber}`}
                onLoad={this.handleLoad}
                onError={this.handleError}
                alt="Company logo"
            />
        );
    }

    handleLoad = e => {
        this.setState({ loaded: true });
    };

    handleError = e => {
        e.target.src = 'https://static.e-conomic.com/secure/agreement_logo_default.svg';
    };
}
